import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=77cddd5b&scoped=true"
import script from "./ExternalLink.vue?vue&type=script&lang=js"
export * from "./ExternalLink.vue?vue&type=script&lang=js"
import style0 from "./ExternalLink.vue?vue&type=style&index=0&id=77cddd5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cddd5b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonsButton: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Buttons/Button.vue').default,ModalsModalCover: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Modals/ModalCover.vue').default})
